import { Injectable } from '@angular/core';
import { AppConfig } from './app-config';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AppConfigService {
  private config: AppConfig;

  constructor() {
    this.config = environment.config;
  }

  load(): Promise<void> {
    return Promise.resolve();
  }

  get AllConfig(): AppConfig {
    return this.config || ({} as AppConfig);
  }

  get ServidorGenerales(): string {
    return this.config?.ServerUploadFiles || '';
  }

  get ServerScUtilities(): string {
    return this.config?.ServerScUtilities || '';
  }

  get ServicioForms(): string {
    const base = this.config?.ServerUploadFiles || '';
    return base.endsWith('/') ? base.slice(0, -1) : base;
  }

  get BlobUrl(): string {
    return this.config?.BlobUrl || '';
  }

  get DocumentIntelligenceUrl(): string {
    return this.config?.DocumentIntelligenceUrl || '';
  }

  get ServidorDocumentos(): string {
    return this.config?.ServidorDocumentos || '';
  }

  get ServidorDocumentosLegacy(): string {
    return this.config?.ServidorDocumentosLegacy || '';
  }

  get ServidorAuth(): string {
    return this.config?.ServidorAuth || '';
  }

  get ServidorPeople(): string {
    return this.config?.ServidorPeople || '';
  }
}
